<!--
 * @Description: 新增人员-基本信息面板组件
 * @Author: wanqian
 * @Date: 2022-03-28 11:23:19
-->
<template>
	<div class="attendant-base-info-body">
		<el-form v-if="baseInfoForm && baseInfoForm.attendant" class="baseInfoForm" ref="baseInfoForm" 
			:model="baseInfoForm.attendant" :rules="rules" label-position="top" label-width="100px">
			<el-row style="margin: 0 5px" :gutter="50" type="flex" justify="space-between">
				<el-col :span="8" style="text-align: left">
					<el-form-item label="所属机构：" prop="institutionId">
						<!-- 编辑时审核通过状态/审核通过后撤回的状态都不能编辑机构、姓名、身份证、身份证图片正反面 -->
						<el-select size="small" style="width: 100%" v-model="baseInfoForm.attendant.institutionText" :disabled="true"
							v-if="readonly || (mode == 'edit' && baseInfoForm && baseInfoForm.review && (baseInfoForm.review.status == 1 
							|| (baseInfoForm.review.status == 3 && baseInfoForm.attendant && baseInfoForm.attendant.sourceOperate == 1)))">
						</el-select>
						<el-select v-else style="width: 100%;" size="small" filterable  v-model="baseInfoForm.attendant.institutionId" clearable 
							placeholder="请输入/选择" :disabled="readonly"
							:filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList', srcInstitutionList, this))"
							@visible-change="(visible) => 
							commonUtil.handleListFilterVisibleChange(visible, 'institutionList', srcInstitutionList, this)"
							@change="handleChangeInstitution">
							<el-option v-for="item in institutionList"
								:key="item.id"
								:label="item.name"
								:disabled="item.disabled"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8" style="text-align: left">
					<el-form-item label="姓名：" prop="name">
						<!-- 编辑时审核通过状态/审核通过后撤回的状态都不能编辑机构、姓名、身份证、身份证图片正反面 -->
						<el-input size="small" style="width: 100%" placeholder="请输入姓名" clearable 
							v-model.trim="baseInfoForm.attendant.name" :readonly="readonly" 
							:disabled="mode == 'edit' && baseInfoForm && baseInfoForm.review && (baseInfoForm.review.status == 1 
							|| (baseInfoForm.review.status == 3 && baseInfoForm.attendant && baseInfoForm.attendant.sourceOperate == 1)) 
							|| (baseInfoForm.attendant.isRealname == 1 && mode == 'edit')"
							oninput="if (value.length > 25) value = value.slice(0, 25)">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8" style="text-align: left">
					<el-form-item label="手机号：" prop="mobile">
							<el-input size="small" style="width: 100%" placeholder="请输入手机号" clearable 
								v-model.trim="baseInfoForm.attendant.mobile" :readonly="readonly" @input="inputPhone">
							</el-input>
						</el-form-item>
				</el-col>
			</el-row>
			<el-row style="margin: 0 5px" :gutter="50" type="flex" justify="space-between">
				<el-col :span="8" style="text-align: left">
					<el-form-item label="身份证号：" prop="idCardNo">
						<!-- 编辑时审核通过状态/审核通过后撤回的状态都不能编辑机构、姓名、身份证、身份证图片正反面 -->
						<el-input size="small" style="width: 100%" placeholder="请输入身份证号" clearable 
							v-model.trim="baseInfoForm.attendant.idCardNo" :readonly="readonly" 
							:disabled="mode == 'edit' && baseInfoForm && baseInfoForm.review && (baseInfoForm.review.status == 1 
							|| (baseInfoForm.review.status == 3 && baseInfoForm.attendant && baseInfoForm.attendant.sourceOperate == 1)) 
							|| (baseInfoForm.attendant.isRealname == 1 && mode == 'edit')" 
							@input="inputIdNum()" @change="changeIdNum">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8" style="text-align: left">
					<el-form-item label="年龄：" prop="age">
						<el-input size="small" style="width: 100%" placeholder="请先输入真实身份证号" clearable 
							v-model.trim="baseInfoForm.attendant.age" :readonly="true">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8" style="text-align: left">
					<el-form-item label="性别：" prop="gender">
						<el-radio-group style="margin: 11px 0"  size="small" v-model="baseInfoForm.attendant.gender" 
							:disabled="true">
							<el-radio v-for="(value, key) in baseInfoForm.genderMap" :key="key" :label="parseInt(key)">
								{{value}}
							</el-radio>
    				</el-radio-group>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row style="margin: 0 5px" :gutter="50" type="flex">
				<el-col :span="8" style="text-align: left">
					<el-form-item label="服务地区：" prop="area">
						<el-select v-if="readonly" size="small" style="width: 100%" v-model="areaText" :disabled="readonly">
						</el-select>
						<el-cascader v-else-if="!readonly && baseInfoForm.provinceList" size="small" style="width: 100%" 
							v-model="baseInfoForm.attendant.area" placeholder="请输入/选择" filterable :disabled="readonly"
							:options="baseInfoForm.provinceList" 
							:props="{ expandTrigger: 'hover',children:'subRegionList',label:'name',value:'id',}">
						</el-cascader>
					</el-form-item>
				</el-col>
				<el-col :span="8" style="text-align: left">
					<el-form-item :label="`\u00a0\u00a0`">
						<el-checkbox v-model="baseInfoForm.attendant.showInMainpage" :true-label="1" :false-label="0">
							用户端机构主页展示Ta的信息
						</el-checkbox>
					</el-form-item>
				</el-col>
				<el-col :span="8" style="text-align: left">
					<el-form-item :label="`\u00a0\u00a0`">
						<el-checkbox v-model="baseInfoForm.attendant.needPayTax" :true-label="1" :false-label="0">
							代交个税
						</el-checkbox>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row style="margin: 0 5px" :gutter="50" type="flex" justify="space-between">
				<el-col :span="16" style="text-align: left">
					<el-form-item label="身份证照片：" prop="idCardImgs">
						<!-- 编辑时审核通过状态/审核通过后撤回的状态都不能编辑机构、姓名、身份证、身份证图片正反面 -->
						<div class="div-back-idcard">
							<div class="upload-idcard upload-idcard-left">
								<!-- 审核状态：0-未审核 1-审核通过 2-审核拒绝 3-撤回	 -->
								<el-upload style="width: 240px; height: 152px;" drag accept="image/jpeg,image/png" action="" 
									v-if="mode == 'add' || (mode == 'edit' && baseInfoForm && (baseInfoForm.review && 
									(baseInfoForm.review.status == 0 || baseInfoForm.review.status == 2 || 
									(baseInfoForm.review.status == 3 && baseInfoForm.attendant && baseInfoForm.attendant.sourceOperate == 0))))" 
									:auto-upload="false" :show-file-list="false" :on-change="handleIdCardImgBackChange">
									<img v-if="!fileIdCardImgBack && !baseInfoForm.attendant.idCardImg2Path" 
										style="margin-top: 25px; width: 107px; height: 71px"
										src="@/assets/common/img-common-idcardback.png" alt="">
  								<div v-if="!fileIdCardImgBack && !baseInfoForm.attendant.idCardImg2Path" class="el-upload__text">
										将文件拖到此处 或 <em>点击上传</em>
									</div>
									<div v-else>
										<el-image style="width: 240px; height: 152px;" :src="urlIdCardImgBack" fit="contain"></el-image>
										<span class="text-hover text-idcard-hover">点击更换图片</span>
									</div>
								</el-upload>
								<div v-else style="width: 240px; height: 152px;">
									<el-image v-if="urlIdCardImgBack" style="width: 100%; height: 100%; background-color: #EBEEF2;" 
										:src="urlIdCardImgBack" :preview-src-list="previewImgList" fit="contain">
									</el-image>
									<div v-else style="width: 100%; height: 100%; background-color: #EBEEF2; text-align: center;">
										<img style="margin-top: 40px; width: 107px; height: 71px" 
											src="@/assets/common/img-common-idcardback.png" alt="">
									</div>
								</div>
								<div class="upload-tip">身份证头像页</div>
								<div v-if="mode != 'details'" class="tip">
									请上传宽度不小于600像素的图片<br/>图片大小不超过
									<span class="tip-red">5M</span>，支持上传<span class="tip-red">png、jpg、jpeg</span>
								</div>
							</div>
							<div class="upload-idcard upload-idcard-right">
								<el-upload style="width: 240px; height: 152px;" drag accept="image/jpeg,image/png" action=""
									v-if="mode == 'add' || (mode == 'edit' && baseInfoForm && (baseInfoForm.review && 
									(baseInfoForm.review.status == 0 || baseInfoForm.review.status == 2 || 
									(baseInfoForm.review.status == 3 && baseInfoForm.attendant && baseInfoForm.attendant.sourceOperate == 0))))"
									:auto-upload="false" :show-file-list="false" :on-change="handleIdCardImgFrontChange">
									<img v-if="!fileIdCardImgFront && !baseInfoForm.attendant.idCardImg1Path" 
										src="@/assets/common/img-common-idcardfront.png"
										 style="margin-top: 25px; width: 107px; height: 71px" alt="">
  								<div v-if="!fileIdCardImgFront && !baseInfoForm.attendant.idCardImg1Path" class="el-upload__text">
										将文件拖到此处 或 <em>点击上传</em>
									</div>
									<div v-else>
										<el-image style="width: 240px; height: 152px;" :src="urlIdCardImgFront" fit="contain"></el-image>
										<span class="text-hover text-idcard-hover">点击更换图片</span>
									</div>
								</el-upload>
								<div v-else style="width: 240px; height: 152px;">
									<el-image v-if="urlIdCardImgFront" style="width: 100%; height: 100%; background-color: #EBEEF2;" 
										:src="urlIdCardImgFront" :preview-src-list="previewImgList" fit="contain">
									</el-image>
									<div v-else style="width: 100%; height: 100%; background-color: #EBEEF2; text-align: center;">
										<img style="margin-top: 40px; width: 107px; height: 71px" 
											src="@/assets/common/img-common-idcardfront.png" alt="">
									</div>
								</div>
								<div class="upload-tip">身份证国徽页</div>
								<div v-if="mode != 'details'" class="tip">
									请上传宽度不小于600像素的图片<br/>图片大小不超过
									<span class="tip-red">5M</span>，支持上传<span class="tip-red">png、jpg、jpeg</span></div>
							</div>
						</div>
					</el-form-item>
				</el-col>
				<el-col :span="8" style="text-align: left" v-if="!baseInfoForm.attendant.needPayTax">
					<el-form-item label="原因：" class="is-required">
						<el-input
								maxlength="100"
								:rows="6"
								class="custom-height"
								type="textarea"
								placeholder="请输入原因"
								v-model="baseInfoForm.attendant.noTaxReason">
						</el-input>
					</el-form-item>
				</el-col>
			</el-row>
	 </el-form>
    <div class="bk-wizard-bottons" style="padding: 10px 25px 30px 0px;">
			<wizard-buttons :mode="mode" :status="btnStatus" @btnpressed="handleBtnSelection" />
	 </div>
	</div>
</template>

<script>
import attendantStore from './AttendantStore.js'
import Constant from '@/global/Constant.js'

let AttendantBaseInfoPanel = {
  name: 'AttendantBaseInfoPanel',
  attendantStore,

  data() {
		let validateMobile = (_rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入手机号'));
			} else if (!this.commonUtil.validateMobile(value)) {
				callback(new Error('请输入正确的手机号码'));
			} else {
				callback();
			}
		};

		let validateIdNo = (_rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入真实身份证号'));
			} else if (value.length != 18 || !this.commonUtil.validateIdCardNo(value)) {
				callback(new Error('请输入正确的身份证号'));
			} else {
				callback();
			}
    };

		let validateIdCardImgs = (_rule, _value, callback) => {
			if (!this.urlIdCardImgBack || this.urlIdCardImgBack.length == 0) {
				callback(new Error('请上传身份证人像面图片'));
			} else if (!this.urlIdCardImgFront || this.urlIdCardImgFront.length == 0) {
				callback(new Error('请上传身份证国徽面图片'));
			} else {
				callback();
			}
		};

		let validateArea = (_rule, _value, callback) => {
			let provinceId = this.baseInfoForm.attendant.area[0];
			let cityId = this.baseInfoForm.attendant.area[1];
			if (!provinceId || provinceId.length == 0 || !cityId || cityId.length == 0) {
				callback(new Error('请选择服务地区'));
			} else {
				callback();
			}
    };

		return {
			btnStatus: {'prev': false, 'next': true, 'submit': false},
			rules: {
				name: [{required: true, message: '请输入姓名', trigger: 'blur'},],
				mobile: [{required: true, validator: validateMobile, trigger: 'blur'},],
				idCardNo: [{required: true, validator: validateIdNo, trigger: 'blur'},],
				institutionId: [{required: true, message: '请选择所属机构', trigger: 'blur'},],
				age: [{required: true, message: '请先输入真实身份证号', trigger: 'blur'},],
				gender: [{required: true, message: '请先输入真实身份证号', trigger: 'blur'},],
				area: [{required: true, validator: validateArea, trigger: 'blur'},],
				idCardImgs: [{required: true,validator: validateIdCardImgs, trigger: 'blur'}],
				needPayTax: [{required: true, message: '请选择是否代交个税', trigger: 'blur'}],
			},
			institutionId: 0,

			institutionList: []
		}
  },

	computed: {
    mode() {
      return attendantStore.state.mode;
    },

    readonly() {
      return attendantStore.state.mode == 'details';
    },
		
		baseInfoForm() {
			console.log(88888888888888888888888888888888888888888888)
			this.institutionList = attendantStore.state.attendantDo.institutionList;
			if (Object.keys(attendantStore.state.attendantDo.attendant).length == 0) this.clearVaild();
			if (attendantStore.state.mode == "edit") {
				this.institutionId = attendantStore.state.attendantDo.attendant.institutionId;
			}
			return attendantStore.state.attendantDo;
		},

		srcInstitutionList() {
      return attendantStore.state.attendantDo.institutionList;
		},

		areaText() {
			if (!attendantStore.state.attendantDo.attendant || !attendantStore.state.attendantDo.attendant.provinceText 
				|| !attendantStore.state.attendantDo.attendant.cityText) {
				return "";
			}
			return attendantStore.state.attendantDo.attendant.provinceText + ' / ' + attendantStore.state.attendantDo.attendant.cityText;
		},

		urlIdCardImgBack() {
			if (attendantStore.state.idCardImgBackFile) {
				return this.commonUtil.file2Url(attendantStore.state.idCardImgBackFile);
			}
			return this.baseInfoForm.attendant.idCardImg2Path 
				? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.baseInfoForm.attendant.idCardImg2Path)
				: '';
    },

		fileIdCardImgBack() {
      return attendantStore.state.idCardImgBackFile ? attendantStore.state.idCardImgBackFile : null;
    },

		urlIdCardImgFront() {
			if (attendantStore.state.idCardImgFrontFile) {
				return this.commonUtil.file2Url(attendantStore.state.idCardImgFrontFile);
			}
			return this.baseInfoForm.attendant.idCardImg1Path 
				? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.baseInfoForm.attendant.idCardImg1Path)
				: '';
    },

		fileIdCardImgFront() {
      return attendantStore.state.idCardImgFrontFile ? attendantStore.state.idCardImgFrontFile : null;
    },

		previewImgList() {
      let imgList = [];
      if (this.baseInfoForm.attendant.idCardImg2Path) {
        imgList.push(this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.baseInfoForm.attendant.idCardImg2Path));
      }
      if (this.baseInfoForm.attendant.idCardImg1Path) {
        imgList.push(this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.baseInfoForm.attendant.idCardImg1Path));
      }
      return imgList;
    }
  },

  methods: {
		handleChangeInstitution(val) {
			this.institutionId = val;
			this.vaildIdNoRepeat();
		},

		//验证身份证重复
		vaildIdNoRepeat() {
      let attendant = this.baseInfoForm.attendant;
			if (!attendant.idCardNo || attendant.idCardNo.length == 0) return;
			if (!this.institutionId) return;
			let id = this.mode == 'add' ? 0 :attendant.id;
			let params= {
        'id': id,
				'institutionId': this.institutionId,
        'idno': attendant.idCardNo
			}; 
			let header = this.encryptionUtil.signatureParams(params,
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET', 
        url: Constant.URL_VAILDATE_IDNO,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
			this.vueRequest(requestData).then(result => {
				attendantStore.commit('changeIsIdNoRepeat', !result || result.code != this.commonConst.RESTFUL_SUCC);
      });
		},

		// 手机号输入改变
		inputPhone() {
			//只能输入数字，最长11位
			this.baseInfoForm.attendant.mobile = this.commonUtil.filterDigitals(this.baseInfoForm.attendant.mobile);
			if (this.baseInfoForm.attendant.mobile.length > 11) {
				this.baseInfoForm.attendant.mobile = this.baseInfoForm.attendant.mobile.slice(0, 11);
			}
		}, 

		//身份证号输入
		inputIdNum() {
			//最长18位
			if (this.baseInfoForm.attendant.idCardNo.length == 18) {
				//奇数是男，偶数是女
				let sex = this.baseInfoForm.attendant.idCardNo.substring(this.baseInfoForm.attendant.idCardNo.length-2
					, this.baseInfoForm.attendant.idCardNo.length-1);
				if (sex % 2 == 0) {
					this.baseInfoForm.attendant.gender = 2;
				} else {
					this.baseInfoForm.attendant.gender = 1;
				}
				this.baseInfoForm.attendant.age = this.commonUtil.calcAgeFromIdNo(this.baseInfoForm.attendant.idCardNo);
			} else {
				this.baseInfoForm.attendant.age = '';
				this.baseInfoForm.attendant.gender = '';
			}
			if (this.baseInfoForm.attendant.idCardNo.length > 18) {
				this.baseInfoForm.attendant.idCardNo = this.baseInfoForm.attendant.idCardNo.slice(0, 18);
			}	
			this.$refs.baseInfoForm.validateField('age');
			this.$refs.baseInfoForm.validateField('gender');
		}, 

		//身份证号输入完成
		changeIdNum() {
			this.vaildIdNoRepeat();
		},

		//改变身份证图片
		handleIdCardImgBackChange(file, _fileList) {
			let limitation = {
				maxSize: Constant.LIMIT_IMG_SIZE_5,
				maxWidth: 600.0,
				maxHeight: 0,
				extLimit: {
					limitType: 2,
					minRatio: 0.1,
					minRatioText: '100:10'
				},
				returnData: {}
			};
			this.imgUtil.validateAndCompressImg(file, limitation).then((data) => {
				if (data.errorText && data.errorText.length) {
					this.$message.error(data.errorText);
				} else {
					attendantStore.commit('changeIdCardImgBackFile', data.file);
				}
			})
		},

		handleIdCardImgFrontChange(file, _fileList) {
			let limitation = {
				maxSize: Constant.LIMIT_IMG_SIZE_5,
				maxWidth: 600.0,
				maxHeight: 0,
				extLimit: {
					limitType: 2,
					minRatio: 0.1,
					minRatioText: '100:10',
				},
				returnData: {}
			};
			this.imgUtil.validateAndCompressImg(file, limitation).then((data) => {
				if (data.errorText && data.errorText.length) {
					this.$message.error(data.errorText);
				} else {
					attendantStore.commit('changeIdCardImgFrontFile', data.file);
				}
			})
		},

		isRealName() {
			return new Promise(resolve => {
				let user = {name: this.baseInfoForm.attendant.name, idno: this.baseInfoForm.attendant.idCardNo}
				let header = this.encryptionUtil.signatureParams(user,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_ATTENDANT_REALNAME,
          param: user,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
				this.vueRequest(requestData).then(result => {
					if (result != null)
						resolve(result.data)
				})
			})
		},

		//下方按钮点击
		handleBtnSelection(operate) {
      if (this.mode == 'details' || operate != 'next')  {
        this.$emit("panel-operate", operate);
        return true;
      }

      this.$refs.baseInfoForm.validate(async (valid) => {
				if (!valid) return false;
				if (!this.baseInfoForm.attendant.needPayTax && !this.baseInfoForm.attendant.noTaxReason) {
					this.$message.error('请输入不代交个税原因');
					return false;
				} else {
					let status = true;
					if (operate == 'next') status = await this.isRealName();
					if (status) {
						this.$emit("panel-operate", operate);
						return false;
					} else {
						this.$message.error('姓名与身份证号不匹配，请核对修改！')
					}
				}
      });
    },

		clearVaild() {
    	this.$nextTick(() => {
        this.$refs["baseInfoForm"].clearValidate();
      });
		},
	},

  destroyed() {
    //销毁的时候同步数据
    attendantStore.commit('changeAttendantDo', this.baseInfoForm);
  },
}
export default AttendantBaseInfoPanel
</script>

<style scope>
.attendant-base-info-body {
	margin: 30px 0 0 0;
}
.baseInfoForm {
	margin-bottom: 60px;
}
.div-back-idcard {
	display: flex;
	flex-direction: row;
}
.upload-idcard {
	margin-top: 5px;
}
.upload-idcard-right {
	margin-left: 30px;
}
</style>
<style>
.attendant-base-info-body .el-form-item {
	margin-bottom: 20px;
}
.attendant-base-info-body .el-form--label-top .el-form-item__label {
	padding: 0px;
	line-height: 26px;
}
/* 以下是身份证上传组件样式修改 */
.attendant-base-info-body  .el-upload-dragger {
	border:none;
	background-color:#EBEEF2;
	width: 240px;
	height: 152px;
	border-radius:0px
}
.attendant-base-info-body .el-upload__text {
	margin-top: -20px;
	font-size: 12px;
	color: #9DA6B3;
}
.attendant-base-info-body .upload-tip {
	margin-top: 10px;
	line-height: 20px;
	text-align: center;
	font-size: 13px;
	color: #657180;
}
.input-search-servicename .el-icon-search:before {
	color: #88A6F7;
	font-weight: bold;
}
.el-upload:hover .text-idcard-hover {
  display: block; 
}
.text-idcard-hover {
  display: none;
  text-align: center;
  z-index: 200;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 152px;
  line-height: 152px;
  background: rgba(124,124,124,0.5500);
  font-size: 18px;
  font-weight: 600;
  color: #FFFFFF;
}
.tip {
  text-align: left;
	margin-top: 10px;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
}
.tip-red {
  color: #FF1515;
}

.custom-height .el-textarea__inner {
	height: 152px;
	margin-top: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/instmng/components/attendantdetails/AttendantBaseInfoPanel.vue